import { render } from "./BaseGameSectionsMenu.vue?vue&type=template&id=6eb4cede&scoped=true"
import script from "./BaseGameSectionsMenu.vue?vue&type=script&lang=js"
export * from "./BaseGameSectionsMenu.vue?vue&type=script&lang=js"

import "./BaseGameSectionsMenu.vue?vue&type=style&index=0&id=6eb4cede&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eb4cede"]])

export default __exports__